import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { GrRevert } from "react-icons/gr";
import { TfiSave } from "react-icons/tfi";
import { TbAnalyze } from "react-icons/tb";
import { BiExpandHorizontal, BiCollapseHorizontal } from "react-icons/bi";
import { GoInfo } from 'react-icons/go';
import Tooltip from "../../controls/common/tooltip";
import "./index.css";

export default class View extends Component {
  handleRevert = () => {
    this.props.shell.shellInterface.revertWorkflow();
  }

  handleSave = () => {
    this.props.shell.shellInterface.saveWorkflow();
  }

  handleCheck = () => {
    this.props.shell.shellInterface.checkWorkflow();
  }

  toggleExpand = () => {
    this.props.shell.shellInterface.toggleWideContent();
  }

  render() {
    return (
      <>
        <div className="workflow-controls-pane-right">
          {this.props.shell.modified ? (
            <>
              <Tooltip text="Revert all changes">
                <Button variant="light" onClick={this.handleRevert}><GrRevert /></Button>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip text="Save changes">
                <Button variant="light" onClick={this.handleSave}><TfiSave /></Button>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip text="Check workflow">
                <Button variant="light" onClick={this.handleCheck}><TbAnalyze /></Button>
              </Tooltip>
            </>
          )}

          &nbsp;&nbsp;
          <Tooltip text="Toggle width">
            <Button variant="light" onClick={this.toggleExpand}>
              {this.props.shell.wideContent
                ? <BiCollapseHorizontal />
                : <BiExpandHorizontal />}
            </Button>
          </Tooltip>

          {!this.props.shell.details.visible &&
            <>
              &nbsp;&nbsp;
              <Tooltip text="Show details">
                <Button variant="light" onClick={() => {
                  this.props.shell.shellInterface.updatePane("details", true);
                }}><GoInfo/></Button>
              </Tooltip>
            </>
          }
        </div>
      </>
    );
  }
}
